var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isUserBlocked)?_c('utility-action-state',{attrs:{"action":_vm.goToAdWatch},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var loading = ref.loading;
var trigger = ref.trigger;
return [_c('v-btn',{staticStyle:{"width":"96px"},attrs:{"loading":loading,"disabled":loading,"rounded":"","color":"primary"},on:{"click":function($event){return _vm.$createOnClick({ support: trigger })}}},[_vm._v("Soutenir")])]}}],null,false,360672522)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }